import React, { FC, useMemo, useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';
import ResourceGroupContext from '../../../components/resource/_ResourceGroupContext';

export interface WithResourceReducerKeyProps {
  name?: string;
  resourceReducerKey?: string;
}

const withResourceReducerKey = (WrappedComponent: FC<WithResourceReducerKeyProps>) => {
  const WithResourceReducerKeyDefaultProps: Partial<WithResourceReducerKeyProps> = {
    name: '',
  };

  const WithResourceReducerKey = (props: WithResourceReducerKeyProps) => {
    const { parentResourceKey } = useContext(ResourceGroupContext) || {};
    const { name } = props;

    const key = useMemo(() => (
      (parentResourceKey && `${parentResourceKey}.resources.${name}`) ||
      name
    ), [parentResourceKey, name]);

    return (
      <WrappedComponent
        resourceReducerKey={key}
        {...props}
      />
    );
  };

  WithResourceReducerKey.defaultProps = WithResourceReducerKeyDefaultProps;
  WithResourceReducerKey.displayName = getWrappedDisplayName('WithResourceReducerKey', WrappedComponent);

  return hoistNonReactStatics(WithResourceReducerKey, WrappedComponent);
};

export default withResourceReducerKey;
